module.exports = __webpack_public_path__ + "img/quiet_Scene1.c04f307c.gif";